import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    primary: {
      main: '#2E7D32', // Verde principal
      light: '#4CAF50',
      dark: '#1B5E20',
    },
    secondary: {
      main: '#FF9800', // Naranja secundario
      light: '#FFA726',
      dark: '#F57C00',
    },
    background: {
      default: '#F1F8E9', // Verde muy claro para el fondo
      paper: '#FFFFFF',
    },
    text: {
      primary: '#1B5E20', // Verde oscuro para texto principal
      secondary: '#558B2F', // Verde medio para texto secundario
    },
  },
  typography: {
    fontFamily: 'Roboto, Noto Color Emoji, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Arial, sans-serif',
    h1: {
      fontSize: '2.5rem',
      fontWeight: 600,
      color: '#1B5E20',
    },
    h2: {
      fontSize: '2rem',
      fontWeight: 600,
      color: '#1B5E20',
    },
    h3: {
      fontSize: '1.75rem',
      fontWeight: 500,
      color: '#1B5E20',
    },
    body1: {
      fontSize: '1rem',
      color: '#2E7D32',
    },
    button: {
      textTransform: 'none',
      fontWeight: 500,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          padding: '8px 16px',
        },
        contained: {
          boxShadow: 'none',
          '&:hover': {
            boxShadow: '0px 2px 4px rgba(0,0,0,0.1)',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: '0px 2px 8px rgba(0,0,0,0.05)',
        },
      },
    },
  },
}); 